export default "__VITE_ASSET__a0849fba__"